import { useEffect } from 'react';

export default function JsonLd({ data }: { data: object }) {
  useEffect(() => {
    let el = document.getElementById('jsonld-page') as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = 'jsonld-page';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, [data]);

  return null;
}